import MinValidator from './MinValidator';

export class MoreValidator extends MinValidator {
    static key = 'more';
}

export default MoreValidator;
